import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.8 5a.79.79 0 00-.8.778v12.444a.79.79 0 00.8.778h14.4c.454 0 .8-.36.8-.778V9.333a.79.79 0 00-.8-.777h-3.104A1.015 1.015 0 0116 8.56H8a1 1 0 110-2h7.5v-.782A.79.79 0 0014.7 5H4.8zM2 5.778C2 4.232 3.265 3 4.8 3h9.9c1.535 0 2.8 1.232 2.8 2.778v.778h1.7c1.535 0 2.8 1.232 2.8 2.777v8.89C22 19.767 20.735 21 19.2 21H4.8C3.265 21 2 19.768 2 18.222V5.778zM15 14a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z",
      fill: "#2d6ded"
    }
  )
), a = t;
export {
  a as default
};
